export default __webpack_public_path__ + "static/white-nr-natural-cork-d549ab1fc0c5bb9a3e73ccc342cebd52.png";